import { withTheme, withStyles } from 'material-ui';
import React, { Component } from 'react';
import loadFile from '../utils/FileLoader';

const styles = {
  content: {
    fontSize: "0.875rem",
    fontWeight: 400,
    fontFamily: "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
    color: "rgba(0, 0, 0, 0.87)",
    '& h1': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    },
    '& h2': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    },
    '& h3': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    },
    '& h4': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    },
    '& h5': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    },
    '& h6': {
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.7)"
    }
  }
};

class FileContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: 'loading',
      content: null
    }
    this.loadFile();
  }

  render() {
    if(this.state.load === 'loading') {
      return <div>Loading...</div>;
    }else if (this.state.load === 'loaded') {
      return <div className={this.props.classes.content} dangerouslySetInnerHTML={{__html: this.state.content}}/>;
    }else if (this.state.load === 'errored') {
      return <div>Unable to load content. Try connecting to the internet, reloading the page, and updating your bundle manifests.</div>;
    }
    
    return null;
  }

  loadFile() {
    loadFile(this.props.url, content=>{
      this.setState({
        load: 'loaded',
        content: content
      });
    }, ()=>{
      this.setState({
        load: 'errored'
      });
    }, 7500);
  }
}

export default withTheme()(withStyles(styles)(FileContent));


// WEBPACK FOOTER //
// ./src/resource_content/FileContent.js